module.exports = __webpack_public_path__ + "static/home_along-b256a2303c9032b1720ef36365dfdb4d.png";